import React, { useContext, useCallback } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { PATH_DASHBOARD, PATH_HOME } from '../../system/constants';
import { AppContext } from '../contexts';
import { BASE_URL, ROUTE_TYPE_CREATE_ACCOUNT, ROUTE_TYPE_CREATE_ACCOUNT_EMP, ROUTE_TYPE_CREATE_ACCOUNT_JS, ROUTE_TYPE_LOGIN, USER_TYPE_EMP, USER_TYPE_JS } from '../constants';
import _get from 'lodash/get';

const AfitdLoginRoute = props => {
    const appContext = useContext(AppContext);
    // const auth = _get(appContext, 'auth');
    const { authUser } = appContext;

    const { type, children, ...rest } = props;

    const getRouteRender = useCallback(
        routeProps => {
            const redirectPathname = _get(routeProps, 'location.pathname', `${BASE_URL}/`);

            if (authUser) {
                return <Redirect to={{ pathname: `${BASE_URL}${PATH_DASHBOARD}` }} />;
            } else if (type === ROUTE_TYPE_LOGIN) {
                // set the original path in the router location state with a flag telling it to show the login dialog
                return <Redirect to={{ pathname: `${BASE_URL}${PATH_HOME}`, state: { redirectPathname, isPromptLogin: true }, push: true }} />;
            } else if (type === ROUTE_TYPE_CREATE_ACCOUNT) {
                // set the original path in the router location state with a flag telling it to show the create account dialog
                return <Redirect to={{ pathname: `${BASE_URL}${PATH_HOME}`, state: { redirectPathname, isPromptCreateAccount: true }, push: true }} />;
            } else if (type === ROUTE_TYPE_CREATE_ACCOUNT_JS) {
                // set the original path in the router location state with a flag telling it to show the create account dialog
                return <Redirect to={{ pathname: `${BASE_URL}${PATH_HOME}`, state: { redirectPathname, isPromptCreateAccount: true, userType: USER_TYPE_JS }, push: true }} />;
            } else if (type === ROUTE_TYPE_CREATE_ACCOUNT_EMP) {
                // set the original path in the router location state with a flag telling it to show the create account dialog
                return <Redirect to={{ pathname: `${BASE_URL}${PATH_HOME}`, state: { redirectPathname, isPromptCreateAccount: true, userType: USER_TYPE_EMP }, push: true }} />;
            } else {
                return children;
            }
        },
        [authUser, type, children],
    );

    return <Route {...rest} render={getRouteRender} />;
};

export default AfitdLoginRoute;
